import React, { useCallback, useEffect } from 'react';
import Grid from '@uber/base-icons/grid';
import { useAtomValue, useSetAtom } from 'jotai';
import ToolbarButton from '../../../../common/toolbar-button';
import { GRID_MODE } from '../../../labelling/constants';
import useShortcut from '../../../labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError } from '../../../labelling/providers/utils/shortcut';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../atoms/label-store-dispatch/events';
import { gridModeAtom } from '../../atoms/tool-atoms';
export const GridControl = () => {
  const gridModeValue = useAtomValue(gridModeAtom);
  const dispatch = useSetAtom(dispatchAtom);
  let {
    registerHotKeys
  } = useShortcut();
  const handleGridSelect = useCallback(() => {
    dispatch({
      type: EVENTS.TOGGLE_GRID_MODE
    });
  }, [dispatch]);
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      keys: ['g'],
      onAction: handleGridSelect
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [handleGridSelect, registerHotKeys]);
  return <ToolbarButton title="Grid" isSelected={gridModeValue !== GRID_MODE.NONE} onClick={handleGridSelect}>
      <Grid title="Grid" />
    </ToolbarButton>;
};